// Czekaj, aż cała strona się załaduje
document.addEventListener('DOMContentLoaded', function() {

    // Znajdź wszystkie linki, które mają href zaczynający się od '#'
    const scrollLinks = document.querySelectorAll('a[href^="#"]');

    // Dla każdego znalezionego linku...
    for (const link of scrollLinks) {
        // ...dodaj nasłuchiwanie na kliknięcie
        link.addEventListener('click', function(event) {

            // 1. Zablokuj domyślną akcję linku (nagłe przeskoczenie)
            event.preventDefault();

            // 2. Pobierz ID sekcji z atrybutu href klikniętego linku
            const targetId = this.getAttribute('href');

            // 3. Znajdź na stronie element o takim ID
            const targetElement = document.querySelector(targetId);

            // 4. Jeśli element istnieje, przewiń do niego płynnie
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth', // To jest klucz do płynnej animacji!
                    block: 'start'      // Wyrównaj do góry sekcji
                });
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    // Klasa identyfikująca pojedynczy element akordeonu
    const itemClass = 'detailed-services-accordion__item';

    // Klasa modyfikatora dla aktywnego (otwartego) elementu
    const activeClass = 'detailed-services-accordion__item--active';

    // Klasa nagłówka, który jest klikalny
    const headerClass = 'detailed-services-accordion__header';

    const accordionItems = document.querySelectorAll(`.${itemClass}`);

    accordionItems.forEach(item => {
        const header = item.querySelector(`.${headerClass}`);

        header.addEventListener('click', () => {
            const isActive = item.classList.contains(activeClass);

            // Opcjonalnie: zamknij wszystkie inne otwarte elementy
            // accordionItems.forEach(otherItem => {
            //     otherItem.classList.remove(activeClass);
            // });

            // Przełączanie klasy modyfikatora
            if (!isActive) {
                item.classList.add(activeClass);
            } else {
                item.classList.remove(activeClass);
            }
        });
    });
});